export default __webpack_public_path__ + "static/media/PropertyDev_IMG-Tropicana.e8527f64.png";